// lib/desktop/native-shell.ts
//
// Ajustes para que la app de escritorio (Tauri) se sienta NATIVA: sin el menú
// contextual del webview (Atrás / Actualizar / Guardar / Imprimir) ni sus
// atajos de teclado de navegador.
//
// Solo se aplica en el build de escritorio (`isDesktopApp()`) y en PRODUCCIÓN.
// En `tauri dev` (import.meta.env.DEV) se dejan intactos para poder inspeccionar.
// En la web (no desktop) no se toca nada: ahí el click derecho es esperable.

import { isDesktopApp } from "@/lib/edition/is-desktop";

export function applyNativeShellBehavior(): void {
  if (typeof window === "undefined") return;
  if (!isDesktopApp()) return;
  if (import.meta.env.DEV) return;

  // 1. Menú contextual del webview (el que trae Atrás/Actualizar/Guardar/Imprimir).
  window.addEventListener("contextmenu", (e) => e.preventDefault());

  // 2. Atajos de navegador que no corresponden a una app nativa: recargar,
  //    imprimir, guardar. (Copiar/pegar/deshacer siguen andando vía Cmd/Ctrl y
  //    el menú Edit en macOS.)
  window.addEventListener(
    "keydown",
    (e) => {
      const k = e.key.toLowerCase();
      const mod = e.ctrlKey || e.metaKey;
      const isReload = k === "f5" || (mod && k === "r");
      const isPrint = mod && k === "p";
      const isSave = mod && k === "s";
      if (isReload || isPrint || isSave) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    { capture: true },
  );
}
